<div class="container">
  <div class="thumbnail">
    <img [src]="thumbnail" [alt]="title"/>
  </div>
  <div class="content">
    <div class="title">{{ title }}</div>
    <div class="description" *ngIf="description">{{ description }}</div>
  </div>
</div>
